
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCompleted as ObiCompletedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-completed.js';
 
 
 

 
 export const ObiCompleted = createComponent({
   react: React,
   tagName: 'obi-completed',
   elementClass: ObiCompletedElement,
   events: {
     
   }
  });
 
 